import React, {
  useEffect,
  useState,
} from 'react';
import ErxWebPage from 'pages/Dashboard/pages/Charts/pages/Details/components/ERx/WebPage';
import {
  PatientForm,
} from 'pages/Dashboard/types/patient';
import {
  useAvailableClinics,
} from 'pages/Dashboard/hooks/useERx';
import Select from 'core/components/Select';
import {
  DosespotClinicMappingInfo,
} from 'dtos';
import isNil from 'lodash/isNil';
import head from 'lodash/head';
import isEmpty from 'lodash/isEmpty';

interface MedicationWebPageProps {
  patient: PatientForm;
}

export default function MedicationWebPage({ patient }: MedicationWebPageProps) {
  const [selectedMapping, setSelectedMapping] = useState<DosespotClinicMappingInfo | null>(null);
  const [hasMultipleClinics, setHasMultipleClinics] = useState<boolean>(false);

  const {
    data,
  } = useAvailableClinics();

  useEffect(() => {
    if (!isEmpty(data?.clinics)) {
      setSelectedMapping(head(data?.clinics) ?? null);
    }
    setHasMultipleClinics((data?.clinics?.length ?? 0) > 1);
  }, [data]);

  const handleChange = (selected: DosespotClinicMappingInfo | DosespotClinicMappingInfo[]) => {
    setSelectedMapping(selected as DosespotClinicMappingInfo);
  };

  return (
    <>
      {
        hasMultipleClinics
        && (
          <div className="mx-4 my-2">
            <Select<DosespotClinicMappingInfo>
              className="min-h-[20px] w-fit"
              disabled={(data?.clinics?.length ?? 0) <= 1}
              muiClasses={{ select: '!py-2 rounded !text-black' }}
              value={selectedMapping}
              placeholder="Select a clinic"
              options={data?.clinics ?? []}
              getValue={(option) => option?.dosespotClinicMappingId ?? 0}
              getLabel={(option) => option?.clinicName}
              onChange={handleChange}
              renderValue={() => selectedMapping?.clinicName ?? 'Select a clinic'}
            />
          </div>
        )
      }
      { !isNil(selectedMapping?.dosespotClinicMappingId)
        && (
        <ErxWebPage
          patient={patient}
          dosespotMappingId={selectedMapping!.dosespotClinicMappingId}
        />
        )}
    </>
  );
}
